// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Skus_skus__main-content__sG5nY {
  margin-block: 4rem 16rem;
  display: grid;
  grid-template-columns: repeat(2, auto);
  column-gap: 5rem;
}

.Skus_skus-grid__Ge1Ev {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 30rem));
  gap: 8rem 5rem;
  position: relative;
}

.Skus_skus-grid__search-text-container__G7Vdv {
  grid-column: -1/1;
  display: flex;
  align-items: center;
  gap: 1.9rem;
  margin-bottom: 3.9rem;
}

.Skus_skus-grid__search-text__MrEzF {
  color: #000;
  font-size: var(--text-xl);
  font-weight: 700;
}

.Skus_skus-grid__search-text-result__AJ1gv {
  color: var(--primary-color);
}
.Skus_skus-grid__search-result-num__WAb7R {
  color: var(--gray-dark);
  font-size: var(--text-base);
  font-weight: 500;
}

.Skus_skus-grid__loading__P2Bfq,
.Skus_skus-grid__empty__8Hdll {
  margin-block: 10rem;
  position: absolute;
  right: 50%;
  transform: translate(50%);
}

.Skus_skus-grid__loading__P2Bfq {
  width: 20rem;
  height: 20rem;
}

.Skus_skus-grid__empty__8Hdll .icon-wrapper {
  padding: 3rem;
}

.Skus_skus-grid__empty__8Hdll .icon {
  width: 6rem;
  height: 6rem;
}

.Skus_skus-grid__pagination__ArcS8 {
  margin-top: 3rem;
  grid-column: -1/1;
  justify-content: flex-end;
}
`, "",{"version":3,"sources":["webpack://./src/components/Skus/Skus.module.css"],"names":[],"mappings":"AAAA;EACE,wBAAwB;EACxB,aAAa;EACb,sCAAsC;EACtC,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,kDAAkD;EAClD,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,qBAAqB;AACvB;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,2BAA2B;AAC7B;AACA;EACE,uBAAuB;EACvB,2BAA2B;EAC3B,gBAAgB;AAClB;;AAEA;;EAEE,mBAAmB;EACnB,kBAAkB;EAClB,UAAU;EACV,yBAAyB;AAC3B;;AAEA;EACE,YAAY;EACZ,aAAa;AACf;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,yBAAyB;AAC3B","sourcesContent":[".skus__main-content {\n  margin-block: 4rem 16rem;\n  display: grid;\n  grid-template-columns: repeat(2, auto);\n  column-gap: 5rem;\n}\n\n.skus-grid {\n  display: grid;\n  grid-template-columns: repeat(3, minmax(0, 30rem));\n  gap: 8rem 5rem;\n  position: relative;\n}\n\n.skus-grid__search-text-container {\n  grid-column: -1/1;\n  display: flex;\n  align-items: center;\n  gap: 1.9rem;\n  margin-bottom: 3.9rem;\n}\n\n.skus-grid__search-text {\n  color: #000;\n  font-size: var(--text-xl);\n  font-weight: 700;\n}\n\n.skus-grid__search-text-result {\n  color: var(--primary-color);\n}\n.skus-grid__search-result-num {\n  color: var(--gray-dark);\n  font-size: var(--text-base);\n  font-weight: 500;\n}\n\n.skus-grid__loading,\n.skus-grid__empty {\n  margin-block: 10rem;\n  position: absolute;\n  right: 50%;\n  transform: translate(50%);\n}\n\n.skus-grid__loading {\n  width: 20rem;\n  height: 20rem;\n}\n\n.skus-grid__empty :global(.icon-wrapper) {\n  padding: 3rem;\n}\n\n.skus-grid__empty :global(.icon) {\n  width: 6rem;\n  height: 6rem;\n}\n\n.skus-grid__pagination {\n  margin-top: 3rem;\n  grid-column: -1/1;\n  justify-content: flex-end;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"skus__main-content": `Skus_skus__main-content__sG5nY`,
	"skus-grid": `Skus_skus-grid__Ge1Ev`,
	"skus-grid__search-text-container": `Skus_skus-grid__search-text-container__G7Vdv`,
	"skus-grid__search-text": `Skus_skus-grid__search-text__MrEzF`,
	"skus-grid__search-text-result": `Skus_skus-grid__search-text-result__AJ1gv`,
	"skus-grid__search-result-num": `Skus_skus-grid__search-result-num__WAb7R`,
	"skus-grid__loading": `Skus_skus-grid__loading__P2Bfq`,
	"skus-grid__empty": `Skus_skus-grid__empty__8Hdll`,
	"skus-grid__pagination": `Skus_skus-grid__pagination__ArcS8`
};
export default ___CSS_LOADER_EXPORT___;
